import MuiButton from './MuiButton';
import MuiChip from './MuiChip';
import MuiFab from './MuiFab';
import MuiFilledInput from './MuiFilledInput';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItemIcon from './MuiListItemIcon';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiSvgIcon from './MuiSvgIcon';
import MuiTab from './MuiTab';
import MuiTableCell from './MuiTableCell';
import MuiTableRow from './MuiTableRow';
import MuiTabs from './MuiTabs';
import MuiFormLabel from './MuiFormLabel';
import MuiAlert from './MuiAlert';
import MuiAlertTitle from './MuiAlertTitle';
import MuiDialogActions from './MuiDialogActions';
import MuiDialog from './MuiDialog';
// import MuiBackdrop from './MuiBackdrop';

export default {
  MuiButton: { styleOverrides: MuiButton },
  MuiChip: { styleOverrides: MuiChip },
  MuiFab: { styleOverrides: MuiFab },
  MuiFilledInput: { styleOverrides: MuiFilledInput },
  MuiIconButton: { styleOverrides: MuiIconButton },
  MuiInputBase: { styleOverrides: MuiInputBase },
  MuiLinearProgress: { styleOverrides: MuiLinearProgress },
  MuiListItemIcon: { styleOverrides: MuiListItemIcon },
  MuiOutlinedInput: { styleOverrides: MuiOutlinedInput },
  MuiSvgIcon: { styleOverrides: MuiSvgIcon },
  MuiTab: { styleOverrides: MuiTab },
  MuiTableCell: { styleOverrides: MuiTableCell },
  MuiTableRow: { styleOverrides: MuiTableRow },
  MuiTabs: { styleOverrides: MuiTabs },
  MuiFormLabel: { styleOverrides: MuiFormLabel },
  MuiAlert: { styleOverrides: MuiAlert },
  MuiAlertTitle: { styleOverrides: MuiAlertTitle },
  MuiDialogActions: { styleOverrides: MuiDialogActions },
  MuiDialog: { styleOverrides: MuiDialog },
  //MuiBackdrop
};
